import React, { useState } from 'react'

import { getErrorMessage } from 'utils'

import { useSnackbar } from 'contexts'
import { useCreateCompanyRole, CompanyRoleListItem } from 'hooks/api'

import { Stack } from '@mui/material'

import { Modal, Button, Input } from '@repo/ui'

interface CreateRoleModalProps {
  open: boolean
  onClose?: () => void
  /** Receives the newly-created role so the caller can navigate to its page. */
  onCreated?: (role: CompanyRoleListItem) => void
}

export const CreateRoleModal = ({ open, onClose = () => {}, onCreated }: CreateRoleModalProps) => {
  const { open: notification } = useSnackbar()
  const [name, setName] = useState('')

  const { mutate: createRole, isPending } = useCreateCompanyRole({
    onSuccess: (role) => {
      handleClose()
      onCreated?.(role)
    },
    onError: (error: any) => {
      notification({ type: 'error', title: getErrorMessage(error) })
    },
  })

  const handleSubmit = () => {
    if (!name.trim()) return
    createRole({ name: name.trim(), permissionIds: [] })
  }

  const handleClose = () => {
    setName('')
    onClose()
  }

  return (
    <Modal
      title="Add role"
      open={open}
      onClose={handleClose}
      actions={
        <>
          <Button variant="secondary" onClick={handleClose} disabled={isPending}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} disabled={!name.trim() || isPending}>
            {isPending ? 'Creating...' : 'Next'}
          </Button>
        </>
      }
    >
      <form
        onSubmit={(e) => {
          e.preventDefault()
          handleSubmit()
        }}
      >
        <Stack spacing={4}>
          <Input
            label="Role name"
            placeholder="Enter"
            value={name}
            onChange={(value: string) => setName(value)}
          />
          {/* Lets Enter submit the form (handleSubmit no-ops on an empty name). */}
          <button type="submit" style={{ display: 'none' }} aria-hidden />
        </Stack>
      </form>
    </Modal>
  )
}
